var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"saved-notice"},[_c('img',{attrs:{"src":_vm.asset('/imgs/icons/saved-check.png'),"alt":"saved"}}),_vm._v(" Saved!\n")])}
var staticRenderFns = []

export { render, staticRenderFns }